import { Compass } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { EditableField } from '@/components/admin/ProfileField';
import { Textarea } from '@/components/ui/textarea';
import { HEARD_ABOUT_OPTIONS, heardAboutLabel } from '@/lib/heardAbout';
import { inputClass, SelectControl, sectionCardClass, sectionTitleClass, sectionTitleStyle } from './controls';

export default function ReferralSection({ person, form, editing = false, setField, title = 'Referral information' }) {
  const view = person || {};
  const draft = form || view;
  const source = editing ? draft : view;
  const hasAgency = Boolean(source.usingAgency || source.agentId);
  // Read the saved answer first. An agency link is a fallback for records
  // created before this question existed, rather than a replacement answer.
  const code = String(source.heardAboutUs || '').trim() || (hasAgency ? 'agency' : '');
  const detail = String(source.heardAboutUsDetail || '').trim();
  return <Card className={sectionCardClass} aria-label="Referral information">
    <CardHeader className="pb-3">
      <CardTitle className={sectionTitleClass} style={sectionTitleStyle}><Compass className="size-4 text-[#D4AF37]" />{title}</CardTitle>
      <p className="text-xs text-[#062B1A]/60">How this person heard about us, including any details provided.</p>
    </CardHeader>
    <CardContent className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <EditableField label="How did you hear about us?" editing={editing && !hasAgency} display={heardAboutLabel(code) || 'Not answered'}>
        <SelectControl value={draft.heardAboutUs || ''} onChange={value => {
          setField?.('heardAboutUs', value);
          if (value === 'agency') setField?.('usingAgency', true);
        }} options={HEARD_ABOUT_OPTIONS} placeholder="Not answered" ariaLabel="How did you hear about us?" />
      </EditableField>
      {(detail || (editing && code === 'other')) && <EditableField label="Source details" editing={editing} display={<span className="whitespace-pre-wrap break-words">{detail}</span>}>
        <Textarea value={draft.heardAboutUsDetail || ''} onChange={event => setField?.('heardAboutUsDetail', event.target.value)} className={inputClass} rows={2} maxLength={200} aria-label="Source details" />
      </EditableField>}
    </CardContent>
  </Card>;
}
